import React from 'react';
import FallbackWrappedElement from '../FallbackWrappedElement/FallbackWrappedElement';
import UserFeedback from 'Routes/Protected/UserFeedback/UserFeedback';

const PatientsForVisit = React.lazy(() =>
  import(
    'Routes/Protected/PatientsForVisit/PatientsForVisit'
  )
);
const AboutUs = React.lazy(() =>
  import('Routes/Protected/AboutUs/AboutUs')
);
const BankAccountList = React.lazy(() =>
  import('Routes/Protected/AccountList/BankAccountList')
);
const ChangePasswrod = React.lazy(() =>
  import('Routes/Protected/ChangePasswrod/ChangePasswrod')
);
const CompleteProfileUser = React.lazy(() =>
  import(
    'Routes/Protected/CompleteProfileUser/CompleteProfileUser'
  )
);
const ContactUs = React.lazy(() =>
  import('Routes/Protected/ContactUs/ContactUs')
);

const Messages = React.lazy(() =>
  import('Routes/Protected/Messages/Messages')
);

const TestFlight = React.lazy(() =>
  import('Routes/Protected/TestFlight/TestFlight')
);
const UploadOnCallDocs = React.lazy(() =>
  import(
    'Routes/Protected/UploadOnCallDocs/UploadOnCallDocs'
  )
);
const Quartering = React.lazy(() =>
  import('Routes/Protected/Quartering/Quartering')
);
const Lab = React.lazy(() =>
  import('Routes/Protected/Lab/Lab')
);

export const ControlledNestedRoutes = (word) => {
  // console.log('word--->', word);

  const nestedroutes = [
    {
      path: '/CompleteProfileUser',
      component: (
        <FallbackWrappedElement>
          <CompleteProfileUser />
        </FallbackWrappedElement>
      ),
      title: word[0],
    },
    {
      path: '/about',
      component: (
        <FallbackWrappedElement>
          <AboutUs />
        </FallbackWrappedElement>
      ),
      title: word[1],
    },
    {
      path: '/UploadOnCallDocs',
      component: (
        <FallbackWrappedElement>
          <UploadOnCallDocs />
        </FallbackWrappedElement>
      ),
      title: word[2],
    },
    {
      path: '/ContactUs',
      component: (
        <FallbackWrappedElement>
          <ContactUs />
        </FallbackWrappedElement>
      ),
      title: word[3],
    },
    {
      path: '/BankAccountList',
      component: (
        <FallbackWrappedElement>
          <BankAccountList />
        </FallbackWrappedElement>
      ),
      title: word[4],
    },
    {
      path: '/ChangePasswrod',
      component: (
        <FallbackWrappedElement>
          <ChangePasswrod />
        </FallbackWrappedElement>
      ),
      title: word[5],
    },
    {
      path: '/testFlight',
      component: (
        <FallbackWrappedElement>
          <TestFlight />
        </FallbackWrappedElement>
      ),
      title: 'Test Flight',
    },
    {
      path: '/messages',
      component: (
        <FallbackWrappedElement>
          <Messages />
        </FallbackWrappedElement>
      ),
      title: word[6],
    },
    {
      path: '/PatientPishNahad',
      component: (
        <FallbackWrappedElement>
          <UserFeedback />
        </FallbackWrappedElement>
      ),
      title: word[10],
    },
    // {
    //   path: '/PatientsForVisit',
    //   component: (
    //     <FallbackWrappedElement>
    //       <PatientsForVisit />
    //     </FallbackWrappedElement>
    //   ),
    //   title: word[11],
    // },
  ];
  return nestedroutes;
};
